/* Recommended products use current catalogue availability. Typed title-only search stays unchanged. */
(function () {
  'use strict';
  const key = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[\s_-]+/g, '');
  function eligible(product) {
    const tags = (product.tags || []).map(key);
    const groups = (product.collections || []).map(key);
    return product.available === true && !Number(product.hidden) &&
      !tags.some(tag => ['balance', 'searchhide', 'soldout'].includes(tag)) &&
      [...tags, ...groups].some(group => ['preorder', 'instock'].includes(group));
  }
  function pick(products, count = 3, random = Math.random) {
    const unique = new Map();
    for (const product of products) {
      const title = String(product.title || '').trim();
      const handle = String(product.handle || '').trim();
      if (title && handle && eligible(product)) unique.set(handle, { title, handle });
    }
    const selected = [...unique.values()];
    for (let i = selected.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [selected[i], selected[j]] = [selected[j], selected[i]];
    }
    return selected.slice(0, count);
  }
  function productPath(product, root = '/') {
    return root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(product.handle);
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { eligible, pick, productPath }; return; }
  let choice;
  async function render() {
    if (!window.BWRelatedSearch) return;
    try {
      choice ||= window.BWRelatedSearch.loadIndex().then(data => pick(data.products));
      const products = await choice;
      document.querySelectorAll('[data-bw-suggestions]').forEach(container => {
        const list = container.querySelector('[data-bw-suggestion-links]');
        if (!list) return;
        list.replaceChildren();
        for (const product of products) {
          const link = document.createElement('a');
          link.href = productPath(product, container.dataset.productsRoot || '/');
          link.append(document.createTextNode(product.title + ' '));
          const arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '→';
          link.append(arrow); list.append(link);
        }
        container.hidden = products.length === 0;
      });
    } catch (_) { choice = null; /* Hide suggestions on failure; search remains usable. */ }
  }
  if (document.querySelector('[data-bw-suggestions]:not(#BWHeaderSearch [data-bw-suggestions])')) render();
  const dialog = document.getElementById('BWHeaderSearch');
  if (dialog) {
    new MutationObserver(() => { if (dialog.hasAttribute('open')) render(); })
      .observe(dialog, { attributes: true, attributeFilter: ['open'] });
    if (dialog.hasAttribute('open')) render();
  }
})();
